module.exports = __webpack_public_path__ + "static/media/discos.6ee26530.png";